export default __webpack_public_path__ + "e9d2b908ba2d522544e1f1c30ff9c7bd.png";